/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Asset_UnsupportedInputs */

const en_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This asset can’t be deposited yet. Choose a different one.`)
};

const de_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Asset kann noch nicht eingezahlt werden. Wählen Sie ein anderes aus.`)
};

const pt_br2_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ativo ainda não pode ser depositado. Escolha outro.`)
};

const tr_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu varlık henüz yatırılamıyor. Farklı bir varlık seçin.`)
};

const zh_cn2_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该资产暂时无法存入，请选择其他资产。`)
};

const zh_hk2_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此資產暫時無法存入，請選擇其他資產。`)
};

const ko_kr2_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 자산은 아직 입금할 수 없습니다. 다른 자산을 선택하세요.`)
};

const ru_ru2_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот актив пока нельзя внести. Выберите другой.`)
};

const es_419_deposit_error_asset_unsupported = /** @type {(inputs: Deposit_Error_Asset_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este activo todavía no se puede depositar. Elige otro.`)
};

/**
* | output |
* | --- |
* | "This asset can’t be deposited yet. Choose a different one." |
*
* @param {Deposit_Error_Asset_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_asset_unsupported = /** @type {((inputs?: Deposit_Error_Asset_UnsupportedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Asset_UnsupportedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_asset_unsupported(inputs)
	if (locale === "de") return de_deposit_error_asset_unsupported(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_asset_unsupported(inputs)
	if (locale === "tr") return tr_deposit_error_asset_unsupported(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_asset_unsupported(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_asset_unsupported(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_asset_unsupported(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_asset_unsupported(inputs)
	return es_419_deposit_error_asset_unsupported(inputs)
});